import { render, staticRenderFns } from "./ModalPanel.vue?vue&type=template&id=1ed79e7e&scoped=true"
import script from "./ModalPanel.vue?vue&type=script&lang=ts"
export * from "./ModalPanel.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1ed79e7e",
  null
  ,true
)

export default component.exports